import './Auth.scss';
import { AuthOuter } from './AuthOuter';
import { useClerk } from '@clerk/clerk-react';

import React, { useEffect } from 'react';

export const SignOutPage = () => {

    const { signOut } = useClerk()
    const myTimer = ms => new Promise(resolve => setTimeout(resolve, ms))

    const signOff = async () => {
        localStorage.removeItem('auth')
        await myTimer(500)
        await signOut({ redirectUrl: '/' })
    }

    useEffect(() => {
        signOff()
    }, [])

    return (
        <AuthOuter title="Sign out">
            <div className="fetch-status">
                signing out<span className="blink_cursor">_</span>
            </div>
        </AuthOuter>
    )
}
